const sizeTableData = {
    knickers: [
        ["Размер", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
        ["Размер Eu", "36", "38", "40", "42", "44", "46", "48"],
        ["Размер талии(см)", "62-66", "66-70", "70-74", "74-78", "78-82", "82-86", "86-90"],
        ["Размер бёдер", "90-94", "94-98", "98-102", "102-106", "106-110", "110-114", "114-118"],
    ],
    bras: [
        ["Размер", "Под грудью (см.)", "AA", "A", "B", "C", "D", "E", "F", "G", "H"],
        ["65", "63-67", "75-77", "77-79", "79 - 81", "81 - 83", "83 - 85", "85 - 87", "87 - 89", "89 - 91", "91 - 93"],
        ["70", "68 - 72", "80 - 82", "82 - 84", "84 - 86", "86 - 88", "88 - 90", "90 - 92", "92 - 94", "94 - 96", "96 - 98"],
        ["75", "73-77", "85-87", "87-89", "89-91", "91-93", "93-95", "95-97", "97-99", "99-101", "101-103"],
        ["80", "78-82", "90-92", "92-94", "94-96", "96-98", "98-100", "100-102", "102-104", "104-106", "106-108"],
        ["85", "83-87", "95-97", "97-99", "99-101", "101-103", "103-105", "105-107", "107-109", "109-111", "111-113"],
        ["90", "88-92", "100-102", "102-104", "104-106", "106-108", "108-110", "110-112", "112-114", "114-116", "116-118"],
        ["95", "93-97", "-", "107-109", "109-111", "111-113", "113-115", "115-117", "117-119", "119-121", "121-123"],
    ],
}

export default sizeTableData
